var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450,
    height: 221,
    viewBox: "0 0 450 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.0002,
    y: 12,
    width: 423,
    height: 208,
    rx: 35,
    fill: "url(#paint0_linear_1_29)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.724 94L261.447 219.96H116L188.724 94Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M341.402 92.8536C331.694 95.079 325.629 104.753 327.854 114.46C330.079 124.168 339.753 130.234 349.461 128.008C359.169 125.783 365.234 116.109 363.009 106.401C360.783 96.6937 351.11 90.6281 341.402 92.8536ZM381.365 186.476L346.21 194.535L331.883 132.038L269.386 146.365L261.327 111.21L323.824 96.8831L309.497 34.3859L344.652 26.327L358.979 88.8241L421.476 74.4971L429.535 109.652L367.038 123.979L381.365 186.476Z",
    fill: "#D2FF3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M337.067 202.033C337.067 211.993 328.993 220.067 319.034 220.067C309.074 220.067 301 211.993 301 202.033C301 192.074 309.074 184 319.034 184C328.993 184 337.067 192.074 337.067 202.033Z",
    fill: "#6843EC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M206.748 69.213L173.705 42.9296L152.095 70.098L98.1248 27.1685L71.8414 60.2112L125.811 103.141L53.9699 193.458L87.0126 219.741L206.748 69.213Z",
    fill: "#040C1F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_29",
    x1: 27.0002,
    y1: 116,
    x2: 450,
    y2: 116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6843EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292929",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup16);
export default __webpack_public_path__ + "static/media/Group 16.75ac74faee7ce1b1b0b8853436c5b2af.svg";
export { ForwardRef as ReactComponent };